import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Calendar
import calendar from "./calendar/reducer";

// Authentication
import forgetPassword from "./auth/forgetpwd/reducer";
import login from "./auth/login/reducer";
import profile from "./auth/profile/reducer";
import account from "./auth/register/reducer";
import IDS from "./appleid/reducer";
import IDQ from "./appleq/reducer";
import GOOGLE from "./google/reducer";
import FACEBOOK from "./facebook/reducer";
import INSTAGRAM from "./instagram/reducer";
import SNAPCHAT from "./snapchat/reducer";
import API from "./apiusers/reducer";
import QRS from "./appleqr/reducer";
const rootReducer = combineReducers({
  // public
  Layout,
  calendar,
  forgetPassword,
  login,
  profile,
  account,
  IDS,
  IDQ,
  API,
  QRS,
});

export default rootReducer;
